import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../app/theme';
import InfoIcon from '../../assets/images/svg/ic-help-circle.svg';
import Toggle from './Toggle';
import Tooltip from './Tooltip';

const useStyles = makeStyles(
  () => ({
    root: {
      marginBottom: 12,
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      '& > img': {
        marginLeft: 4,
      },
    },
    required: {
      color: color.$17,
    },
    subtitle: {
      width: '100%',
      marginTop: 8,
      '& p': {
        fontSize: 13,
        lineHeight: '13px',
        color: color.$13,
        margin: '0',
      },
      '& a': {
        color: color.$2,
        textDecoration: 'underline',
      },
    },
  }),
  {
    name: 'RowTitle',
  },
);

const RowTitle = ({
  title,
  titleStyle = {},
  isRequired,
  subtitle,
  subtitleStyle = {},
  tooltip,
  isEnableSwitch,
  isChecked = false,
  onSwitchChange,
  disabled,
  titleChildren,
  ...otherProps
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root} {...otherProps}>
      {title && (
        <div className={classes.title} style={titleStyle}>
          {title}
          {isRequired && <div className={classes.required}>*</div>}
          {tooltip && (
            <Tooltip
              light
              placement="top"
              title={tooltip}
              style={{ marginLeft: 4 }}
            >
              <InfoIcon />
            </Tooltip>
          )}
          {isEnableSwitch && (
            <Toggle
              onChange={onSwitchChange}
              checked={isChecked}
              disabled={disabled}
            />
          )}
          {titleChildren && titleChildren}
        </div>
      )}
      {subtitle && (
        <div className={classes.subtitle}>
          <p style={subtitleStyle}>{subtitle}</p>
        </div>
      )}
    </div>
  );
};

export default RowTitle;
